import ContactForm, { handleQueryString } from './contact-form';

export { ContactForm as default, handleQueryString };



// WEBPACK FOOTER //
// ./src/index.js